export default __webpack_public_path__ + "static/media/working-women.7a5d5889.gif";